<script>

import ModelB from "@/views/SmartLogistics/ModelB.vue";

export default {
  name: 'ModelC',
  extends: ModelB
}
</script>


<style scoped lang="scss">

</style>